import { Grading } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import {
  PendingReviewModal,
  usePendingReviewModalStore
} from 'modules/orders/components/PendingReviewModal'
import { ActionsItemProps } from './actions'

export const PendingReview = ({ order, disabled }: ActionsItemProps) => {
  const isModalOpen = usePendingReviewModalStore.useIsModalOpen()
  const setModalIsOpen = usePendingReviewModalStore.useSetModalIsOpen()
  const setProposalId = usePendingReviewModalStore.useSetProposalId()

  const handleClick = () => {
    setModalIsOpen(true)
    setProposalId(order.proposalId)
  }

  return (
    <>
      <MenuItem onClick={handleClick} disableRipple disabled={disabled}>
        <Grading />
        Analisar Pendência
      </MenuItem>

      {isModalOpen && <PendingReviewModal />}
    </>
  )
}
